import { render, staticRenderFns } from "./examineModel.vue?vue&type=template&id=39bf66ca&scoped=true"
import script from "./examineModel.vue?vue&type=script&lang=js"
export * from "./examineModel.vue?vue&type=script&lang=js"
import style0 from "./examineModel.vue?vue&type=style&index=0&id=39bf66ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bf66ca",
  null
  
)

export default component.exports